<template>
  <LoginLayout>
    <template #container>
      <LoginContainer
        :title="indexTitle"
        :subTitle="subTitle"
        :switch-text="switchText"
        @switchTo="toRegister"
        :has-back="!isIndex && !fromGuest"
        @back="back"
        :businessType="businessType"
      >
        <template #logo v-if="isMobile && currentLogo">
          <img
            :src="currentLogo"
            alt="porsche logo"
            v-if="hasCustomLoginPage"
            :class="'logo-' + businessType"
          />
        </template>
        <template #form>
          <div
            class="login-tab"
            ref="loginTabRef"
            v-if="isIndex && hasMoreSignInMethod"
          >
            <span
              v-for="item in signInMethodLists"
              :key="item.id"
              :class="{ active: tabType === item.name }"
              @click="valueChange(item.name)"
              >{{ $t(`login.loginPage.${item.name}`) }}</span
            >
            <i class="login-type-dot"></i>
          </div>
          <component ref="form" :is="component" />
        </template>
      </LoginContainer>
    </template>
  </LoginLayout>
</template>
<script>
import LoginLayout from '@/components/login/LoginLayout.vue'
import LoginContainer from '@/components/login/LoginContainer.vue'
import LoginFooter from '@/components/login/LoginFooter.vue'
import Porsche from './Porsche.vue'
import Zlzp from './Zlzp.vue'
import Aia from './aia/Aia.vue'
import AiaHR from './aia-hr/Aia.vue'
import NjcbMeets from './njcb-meets/index.vue'
import Nissan from './nissan/index.vue'
import Aiahrn from './aiahrn/index.vue'
import Takedaspark from './takedaspark/index.vue'
import BaseMixin from '@/mixins/BaseMixin'
import Cim from './cim/Index.vue'
import { mapGetters } from 'vuex'
import { getBusinessType } from '@/constant'

const componentMaps = {
  porsche: Porsche,
  zlzp: Zlzp,
  aia: Aia,
  'aia-hr': AiaHR,
  cim: Cim,
  'njcb-meets': NjcbMeets,
  nissan: Nissan,
  aiahrn: Aiahrn,
  takedaspark: Takedaspark,
}

export default {
  components: {
    LoginLayout,
    LoginContainer,
    LoginFooter,
    Porsche,
    Zlzp,
    Aia,
    NjcbMeets,
    Takedaspark,
  },
  mixins: [BaseMixin],
  props: {},
  data() {
    return {
      input: '',
      tabType: '',
    }
  },
  computed: {
    ...mapGetters(['eventData']),
    component() {
      //  const res = ['Porsche', 'Zlzp', 'Aia', 'NjcbMeets'].filter(item => item === getBusinessType().id[0].toUpperCase() + getBusinessType().id.substr(1))[0]
      const id = getBusinessType().id || ''

      return componentMaps[id]
    },
    hasMoreSignInMethod() {
      // 登录方式为一种 则不显示dot
      return getBusinessType().signInMethods.length > 1
    },
    hasCustomLoginPage() {
      return getBusinessType().hasCustomLoginPage
    },
    switchText() {
      return this.isMobile
        ? this.$t('login.loginPage.newSignup')
        : this.$t('login.loginPage.SignUp')
    },
    currentLogo() {
      return getBusinessType().logo
    },
    signInMethodLists() {
      let methods = []
      const currentSignInMethod = getBusinessType().signInMethods
      currentSignInMethod.map((connector, index) => {
        methods.push({
          id: index,
          name: connector,
        })
      })
      return methods
    },
    indexTitle() {
      // 如果有一万个南京银行要求不同的标题
      return this.$t(`login.loginPage.${getBusinessType().sloganFromLocal}`)
    },
    subTitle() {
      return getBusinessType().subTitleFromLocal
        ? this.$t(`login.loginPage.${getBusinessType().subTitleFromLocal}`)
        : ''
    },
    businessType() {
      return getBusinessType().id
    },
  },
  methods: {
    back() {
      this.$refs['form'].back()
    },
    toRegister() {
      const toType = this.hasBanner ? '/detail' : '/account'
      this.$router
        .push({
          path: '/register/' + this.type + toType,
          query: { ...this.$route.query },
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.logo-porsche {
  height: 70px;
}
.logo-njcb-meets {
  height: 70px;
}
.logo-nissan {
  width: 100%;
}
.logo-zlzp {
  height: 70px;
  align-self: center;
}
.custom-login-footer {
  position: absolute;
  bottom: 16px;
}
.login-tab {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 7px 0 8px;
  margin-bottom: 24px;
  & > span {
    color: #6e7191;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: block;
    cursor: pointer;
  }
  .active {
    color: #14142a;
    position: relative;
  }
  .login-type-dot {
    width: 8px;
    height: 8px;
    background: #14142b;
    display: inline-block;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 100%;
    transform: translateX(77px);
  }
}
</style>
